export default (hit, isInit) => {
  let date = new Date(hit.date.date)
  date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`

  return `
  <div class="card-press card-press--${hit.tag[0] === 'Laïta' ? 'laita' : 'brands'} ${hit.tag[0] === 'Laïta' ? 'bg-sea-blue text-white' : 'bg-sky-blue text-indigo-blue'}">
    <svg width="173" height="157" class="icon--white card-press__icon">
      <use href="#icon-press-thiner" xlink:href="#icon-press-thiner" />
    </svg>

    <div class="card-actu__headline items-center mb-5">
      <span class="mr-4">${date}</span>
      ${hit.tag.length > 0
        ? `<span class="card-press__tag">${hit.tag[0]}</span>`
        : ''
      }
    </div>
    
    <div>
      <p class="title title--semibold title--4">${hit.title}</p>
    
      <div class="flex ${hit.link ? 'justify-between' : 'justify-end'} items-end mt-2">
        ${hit.link
          ? `<a href="${hit.link}" target="_blank" class="cta cta--icon mb-2">
              ${config.trads['press.go_website']}
              <svg width="13" height="10" class="icon--${hit.tag[0] === 'Laïta' ? 'white' : 'indigo-blue'}">
                <use href="#icon-arrow-right" xlink:href="#icon-arrow-right" />
              </svg>
            </a>`
          : ''}

        <a onclick="_paq.push(['trackEvent', 'communique-de-presse', 'newsroom', 'telecharger']);" href="https://res.cloudinary.com/dl8lvr6ag/image/upload/${hit.pdf.singleMedia.publicId}" target="_blank" class="card-press__cta rounded-bottom-right ${hit.tag[0] === 'Laïta' ? 'bg-sky-blue' : 'bg-indigo-blue'}">
          <svg width="17" height="16" class="icon--${hit.tag[0] === 'Laïta' ? 'sea-blue' : 'white'}">
            <use href="#icon-dl" xlink:href="#icon-dl" />
          </svg>
          <span class="sr-only">${config.trads['press.pdf']}</span>
        </a>
      </div>
    </div>
  </div>
  `
}
